module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-hero.94e1a60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-hero.jpg
// module id = F6ei
// module chunks = 0